<template>
  <v-app class="fluxo-vendas-page">
    <!-- Container 1: Filtros -->
    <v-container style="margin: 0px !important; padding: 0px !important">
      <v-container fluid style="margin: 0px">
        <v-card
          elevation="0"
          style="
            margin-top: 0px !important;
            margin-bottom: -30px !important;
            overflow: hidden;
            background-color: transparent;
          "
          class="px-5 py-1"
        >
          <v-row
            class="custom-gray-background fill-width filter-row"
            dense
            align="end"
            v-if="mostrarFiltro"
          >
            <v-col cols="12" sm="6" md="3" lg="3">
              <span>Empresa</span>
              <v-select
                v-model="selectedCompany"
                :items="companyOptions"
                label="Empresa"
                item-text="text"
                item-value="value"
                dense
                solo-inverted
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <span>Filtrar por</span>
              <v-select
                v-model="selectMode"
                :items="['Data da Venda']"
                label="Filtrar"
                dense
                solo-inverted
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2">
              <span>Data Inicial</span>
              <v-menu
                v-model="isStartDatePickerOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="selectedStartDate"
                    label="Data inicial"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="selectedStartDateISO"
                  @input="handleStartDateSelection"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2">
              <span>Data Final</span>
              <v-menu
                v-model="isEndDatePickerOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="selectedEndDate"
                    label="Data final"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="selectedEndDateISO"
                  @input="handleEndDateSelection"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-divider v-if="mostrarFiltro"></v-divider>

          <v-card-actions class="filter-actions">
            <v-btn
              @click="alternarVisibilidade"
              color="#4682B4"
              small
              class="mr-2"
              style="font-size: 14px !important; font-weight: bold"
            >
              {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
              <v-icon style="margin-left: 8px" dark>{{
                mostrarFiltro ? "mdi-eye-off" : "mdi-eye"
              }}</v-icon>
            </v-btn>

            <v-btn
              @click="limparFiltro"
              v-if="mostrarFiltro"
              color="#4682B4"
              small
              outlined
              class="mr-2"
              style="font-size: 14px !important; font-weight: bold"
            >
              Limpar
            </v-btn>
            <v-btn
              @click="applyRequiredFilters"
              v-if="mostrarFiltro"
              color="#4682B4"
              small
              :loading="isLoading"
              style="font-size: 14px !important; font-weight: bold"
            >
              Filtrar <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-container>

    <!-- Container 2: Indicadores -->
    <v-container fluid class="indicadores-container">
      <v-row dense>
        <v-col
          v-for="metric in boardMetrics"
          :key="metric.key"
          cols="12"
          sm="6"
          md="3"
        >
          <base-material-stats-card
            :color="metric.color"
            elevation="1"
            :icon="metric.icon"
            :title="metric.label"
            :value="isLoading ? '...' : metric.value"
            :valuex="false"
            sub-text=""
          />
        </v-col>
      </v-row>
    </v-container>

    <!-- Container 3: Kanban / Lista -->
    <v-container fluid style="background-color: #eee">
      <base-material-card
        icon="mdi-cart-check"
        color="primary"
        title="Vendas"
        style="margin-top: 20px !important; padding-top: 10px !important"
        class="px-5 py-0"
      >
        <v-row class="board-filters-row mt-1" dense align="center">
          <v-col cols="12" sm="6" md="3" lg="3">
            <v-text-field
              v-model="filters.search"
              label="Buscar por cliente ou contrato"
              prepend-inner-icon="mdi-magnify"
              class="board-filter-input"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col v-if="canViewAllSellers" cols="12" sm="6" md="3" lg="2">
            <v-select
              v-model="filters.seller"
              :items="sellerOptions"
              label="Vendedor"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col
            v-if="contractTypeOptions.length"
            cols="12"
            sm="6"
            md="3"
            lg="2"
          >
            <v-select
              v-model="filters.contractType"
              :items="contractTypeOptions"
              label="Tipo contrato"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-select
              v-model="filters.lateInstallments"
              :items="lateInstallmentOptions"
              label="Parcelas em atraso"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
            ></v-select>
          </v-col>
          <v-col cols="12" sm="auto" class="board-filter-actions">
            <v-btn
              small
              outlined
              color="primary"
              class="subtle-action-btn"
              @click="clearFilters"
            >
              <v-icon small>mdi-filter-remove-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-alert
          v-if="filterAlert && !hasAppliedRequiredFilters"
          dense
          text
          type="info"
          class="mt-4 mb-0"
        >
          {{ filterAlert }}
        </v-alert>

        <div class="fluxo-view-toolbar">
          <v-btn-toggle
            v-model="boardViewMode"
            mandatory
            class="fluxo-view-toggle"
          >
            <v-btn value="kanban">
              <v-icon size="18" left>mdi-view-dashboard-outline</v-icon>
              Kanban
            </v-btn>

            <v-btn value="list">
              <v-icon size="18" left>mdi-format-list-bulleted</v-icon>
              Lista
            </v-btn>
          </v-btn-toggle>
        </div>

        <div class="pt-3 pb-2">
          <fluxo-tipo-etapa-chips
            v-model="tiposEtapaFiltroSelecionados"
            :items="tiposEtapaFiltroItems"
          />
        </div>

        <div v-if="boardViewMode === 'list'" class="ticket-list-view mt-6">
          <v-data-table
            :headers="listHeaders"
            :items="listCards"
            :items-per-page="25"
            :loading="isLoading"
            class="ticket-list-table no-hover-effect"
            dense
          >
            <template v-slot:item="row">
              <tr
                :class="{ 'cor-row': row.index % 2 !== 0 }"
                class="pointer"
                @click="selectCard(row.item)"
              >
                <td class="linha etapa-lista-cell">
                  <v-chip x-small dark :color="row.item.stageColor">
                    {{ row.item.stageName }}
                  </v-chip>
                </td>
                <td class="linha cliente-lista-cell">
                  {{ row.item.customerName || "-" }}
                  <div class="lista-subtexto">
                    {{ row.item.document || "-" }}
                  </div>
                </td>
                <td class="linha">{{ row.item.contractNumber || "-" }}</td>
                <td class="linha">{{ row.item.contractType || "-" }}</td>
                <td class="linha">{{ row.item.sellerName || "-" }}</td>
                <td class="linha">{{ formatDate(row.item.saleDate) }}</td>
                <td class="linha text-right">
                  {{ row.item.totalInstallments }}
                </td>
                <td class="linha">
                  <div class="late-chip-row">
                    <v-chip
                      v-for="numero in row.item.lateInstallments"
                      :key="`${row.item.id}-late-${numero}`"
                      x-small
                      class="late-chip"
                    >
                      {{ getLateInstallmentLabel(numero) }}
                    </v-chip>
                    <span v-if="!row.item.lateInstallments.length">-</span>
                  </div>
                </td>
                <td class="linha text-right">
                  {{ formatCurrency(row.item.overdueAmount) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>

        <div v-else class="kanban-board mt-12">
          <div class="kanban-columns">
            <section
              v-for="column in visibleColumns"
              :key="column.id"
              class="kanban-column"
            >
              <div
                class="column-header"
                :style="{ backgroundColor: column.color, opacity: 0.9 }"
              >
                <div class="d-flex align-center">
                  <div
                    class="column-icon"
                    :style="{ backgroundColor: column.color }"
                  >
                    <v-icon color="white" small>{{ column.icon }}</v-icon>
                  </div>
                  <div class="min-width-0">
                    <h3 class="column-title">{{ column.title }}</h3>
                    <p class="column-description">{{ column.description }}</p>
                  </div>
                </div>
                <div class="column-stats">
                  <v-chip
                    x-small
                    color="grey lighten-3"
                    text-color="grey darken-3"
                  >
                    {{ getCardsByColumn(column.id).length }}
                  </v-chip>
                  <strong>{{
                    formatCurrency(getColumnTotal(column.id))
                  }}</strong>
                </div>
              </div>

              <div class="card-list">
                <transition-group name="fade" type="transition" tag="div">
                  <v-card
                    v-for="card in getVisibleCardsByColumn(column.id)"
                    :key="card.id"
                    class="finance-card"
                    elevation="1"
                    rounded="lg"
                    :style="`border-left: 6px solid ${column.color}`"
                    @click="selectCard(card)"
                  >
                    <v-card-text class="pa-3">
                      <div class="card-code">{{ card.code }}</div>
                      <div class="card-customer-row">
                        <h4 class="card-customer">{{ card.customerName }}</h4>
                      </div>

                      <p class="card-description">{{ card.contractType }}</p>

                      <div class="card-amount-row">
                        <div>
                          <span>Valor Inadimplente</span>
                          <small>{{ getInstallmentsLabel(card) }}</small>
                        </div>
                        <strong>{{ formatCurrency(card.overdueAmount) }}</strong>
                      </div>

                      <div class="card-dates">
                        <span>
                          <v-icon small>mdi-cart-outline</v-icon>
                          <strong>Venda:</strong>
                          {{ formatDate(card.saleDate) }}
                        </span>
                        <span>
                          <v-icon small>mdi-file-document-outline</v-icon>
                          <strong>Contrato:</strong>
                          {{ formatDate(card.contractDate) }}
                        </span>
                        <span v-if="card.cancellationDate">
                          <v-icon small>mdi-cancel</v-icon>
                          <strong>Cancelamento:</strong>
                          {{ formatDate(card.cancellationDate) }}
                        </span>
                      </div>

                      <div class="card-meta">
                        <span>
                          <v-icon small>mdi-account-tie-outline</v-icon>
                          {{ card.sellerName || "-" }}
                        </span>
                      </div>

                      <div v-if="card.lateInstallments.length" class="card-tags">
                        <v-chip
                          v-for="numero in card.lateInstallments"
                          :key="`${card.id}-late-${numero}`"
                          x-small
                          class="late-chip"
                        >
                          <v-icon x-small left>mdi-alert-circle-outline</v-icon>
                          {{ getLateInstallmentLabel(numero) }}
                        </v-chip>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-btn
                    v-if="hasMoreCards(column.id)"
                    :key="`${column.id}-load-more`"
                    text
                    small
                    block
                    color="primary"
                    class="load-more-btn mt-2"
                    @click="loadMoreCards(column.id)"
                  >
                    <v-icon small left>mdi-chevron-down</v-icon>
                    Ver mais ({{
                      getCardsByColumn(column.id).length -
                      (columnCardsLimit[column.id] || initialCardsPerColumn)
                    }}
                    restantes)
                  </v-btn>

                  <div
                    v-if="getCardsByColumn(column.id).length === 0"
                    :key="`${column.id}-empty`"
                    class="empty-column"
                  >
                    <span>Nenhum contrato nesta etapa</span>
                  </div>
                </transition-group>
              </div>
            </section>
          </div>
        </div>
      </base-material-card>
    </v-container>

    <v-dialog v-model="detailDialog" max-width="920" scrollable persistent>
      <v-card v-if="selectedCard" class="customer-dialog">
        <v-btn
          text
          small
          class="dialog-close-btn"
          @click="detailDialog = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="text-h3 dialog-title">
          <div class="dialog-header">
            <div class="min-width-0">
              <h2 class="dialog-customer">{{ selectedCard.customerName }}</h2>
              <div class="dialog-contract">
                <strong>{{ selectedCard.contractNumber }}</strong>
                <span class="mx-1">•</span>
                <span>{{ formatCpfMasked(selectedCard.document) }}</span>
                <span class="mx-1">•</span>
                <span>Venda #{{ selectedCard.id_venda }}</span>
              </div>
            </div>
            <div class="dialog-amount">
              <span>Valor Inadimplente</span>
              <strong>{{ formatCurrency(selectedCard.overdueAmount) }}</strong>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="dialog-body pt-0">
          <div class="dialog-tags">
            <v-chip small dark :color="selectedCard.stageColor">
              {{ selectedCard.stageName }}
            </v-chip>
            <v-chip small outlined color="blue-grey">
              {{ getInstallmentsLabel(selectedCard) }}
            </v-chip>
            <v-chip
              v-for="numero in selectedCard.lateInstallments"
              :key="`dialog-late-${numero}`"
              small
              class="late-chip"
            >
              <v-icon small left>mdi-alert-circle-outline</v-icon>
              {{ getLateInstallmentLabel(numero) }}
            </v-chip>
          </div>

          <v-tabs
            v-model="detailTab"
            centered
            show-arrows
            class="custom-tabs mt-4"
            color="primary"
          >
            <v-tab v-for="tab in detailTabs" :key="tab.key">
              {{ tab.label }}
            </v-tab>
          </v-tabs>

          <v-progress-linear
            v-if="loadingCardDetails"
            indeterminate
            color="primary"
            height="2"
          ></v-progress-linear>

          <v-tabs-items v-model="detailTab" class="detail-tabs-content mt-0">
            <v-tab-item>
              <div class="detail-section">
                <div class="section-kicker">
                  <v-icon small>mdi-heart-outline</v-icon>
                  Plano contratado
                </div>
                <h3 class="section-title">
                  {{ selectedCard.contractType || "Plano não informado" }}
                </h3>
                <div class="section-subtitle">
                  Data de adesão: {{ formatDate(selectedCard.contractDate) }}
                </div>

                <div class="data-grid">
                  <div
                    v-for="item in customerDataItems"
                    :key="item.key"
                    class="data-item"
                  >
                    <v-icon small>{{ item.icon }}</v-icon>
                    <span :title="item.value">{{ item.value }}</span>
                  </div>
                </div>

                <div class="section-kicker mt-4">
                  <v-icon small>mdi-shield-outline</v-icon>
                  Sinistros
                </div>
                <div v-if="selectedCard.claims.length">
                  <div
                    v-for="claim in selectedCard.claims"
                    :key="claim.id"
                    class="record-row"
                  >
                    <div>
                      <strong>{{ claim.title }}</strong>
                      <span>{{ formatDate(claim.date) }}</span>
                    </div>
                    <v-chip small outlined color="blue-grey">{{
                      claim.status
                    }}</v-chip>
                  </div>
                </div>
                <div v-else class="empty-detail">
                  Nenhum sinistro registrado.
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="detail-section">
                <div class="installment-filter">
                  <div class="d-flex align-center">
                    <span>Histórico das mensalidades</span>
                    <v-btn
                      small
                      text
                      color="primary"
                      class="ml-2 subtle-action-btn"
                      :title="
                        installmentSortDesc
                          ? 'Vencimento: mais recente primeiro'
                          : 'Vencimento: mais antigo primeiro'
                      "
                      @click="toggleInstallmentSort"
                    >
                      <v-icon small left>
                        {{
                          installmentSortDesc
                            ? "mdi-sort-calendar-descending"
                            : "mdi-sort-calendar-ascending"
                        }}
                      </v-icon>
                      Vencimento
                      {{ installmentSortDesc ? "↓" : "↑" }}
                    </v-btn>
                  </div>
                  <div>
                    <v-chip
                      v-for="filter in installmentFilters"
                      :key="filter.key"
                      small
                      class="mr-1 mb-1"
                      :color="
                        installmentFilter === filter.key
                          ? 'primary'
                          : 'grey lighten-4'
                      "
                      :text-color="
                        installmentFilter === filter.key
                          ? 'white'
                          : 'blue-grey darken-2'
                      "
                      @click="setInstallmentFilter(filter.key)"
                    >
                      {{ filter.label }}
                    </v-chip>
                  </div>
                </div>

                <div v-if="filteredInstallments.length">
                  <div
                    v-for="installment in paginatedInstallments"
                    :key="installment.id"
                    class="installment-row"
                  >
                    <v-chip
                      small
                      :color="
                        getInstallmentStatusConfig(installment.status).color
                      "
                      dark
                      class="installment-status"
                    >
                      {{ getInstallmentStatusConfig(installment.status).label }}
                    </v-chip>

                    <div class="installment-main">
                      <strong>
                        {{ installment.reference || "Sem identificação" }}
                      </strong>
                      <span>
                        #{{ installment.id }}
                        <template v-if="installment.type">
                          · {{ installment.type }}
                        </template>
                      </span>
                    </div>

                    <div class="installment-values">
                      <span>Valor da parcela</span>
                      <strong>{{ formatCurrency(installment.amount) }}</strong>
                      <template v-if="installment.paidAmount != null">
                        <span>Valor recebido</span>
                        <strong class="received-value">
                          {{ formatCurrency(installment.paidAmount) }}
                        </strong>
                      </template>
                    </div>

                    <div class="installment-dates">
                      <span>
                        <v-icon x-small>mdi-calendar-outline</v-icon>
                        Vencimento: {{ formatDate(installment.dueDate) }}
                      </span>
                      <span v-if="installment.paidDate">
                        <v-icon x-small color="teal"
                          >mdi-check-circle-outline</v-icon
                        >
                        Pagamento: {{ formatDate(installment.paidDate) }}
                      </span>
                      <span v-else>
                        <v-icon x-small>mdi-minus-circle-outline</v-icon>
                        Pagamento não realizado
                      </span>
                    </div>
                  </div>
                  <v-pagination
                    v-if="totalInstallmentsPages > 1"
                    v-model="installmentsPage"
                    :length="totalInstallmentsPages"
                    :total-visible="5"
                    class="mt-4"
                  ></v-pagination>
                </div>
                <div v-else class="empty-detail">
                  Nenhuma parcela encontrada para este filtro.
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="detail-section">
                <div v-if="paginatedAgreements.length">
                  <div
                    v-for="agreement in paginatedAgreements"
                    :key="agreement.id"
                    class="record-row"
                  >
                    <div>
                      <strong>{{ agreement.title }}</strong>
                      <span>
                        {{ formatDate(agreement.date) }}
                        -
                        {{ formatCurrency(agreement.amount) }}
                      </span>
                    </div>
                    <v-chip small outlined color="primary">{{
                      agreement.status
                    }}</v-chip>
                  </div>
                  <v-pagination
                    v-if="totalAgreementsPages > 1"
                    v-model="agreementsPage"
                    :length="totalAgreementsPages"
                    :total-visible="5"
                    class="mt-4"
                  ></v-pagination>
                </div>
                <div v-else class="empty-detail">Nenhum acordo registrado.</div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import fluxoVendasService, {
  ETAPAS_VENDAS,
} from "@/services/fluxoVendas.service";
import FluxoTipoEtapaChips from "./components/FluxoTipoEtapaChips.vue";

const EMPRESAS = [
  "A FLOR DO CAFÉ",
  "CEMITERIO PREVIDA",
  "CEMITERIO PREVIDA SÃO MIGUEL",
  "MEMORIAL PARQUE MACEIÓ",
  "PARQUE DAS FLORES",
  "PARQUE DO AGRESTE",
  "PREVIDA",
];

const INADIMPLENTES = [
  ETAPAS_VENDAS.INAD_1_PARCELA,
  ETAPAS_VENDAS.INAD_2_PARCELA,
  ETAPAS_VENDAS.INAD_3_PARCELA,
];

export default {
  name: "FluxoVendas",
  components: {
    FluxoTipoEtapaChips,
  },
  data() {
    return {
      isLoading: false,
      detailDialog: false,
      selectedCard: null,
      loadingCardDetails: false,
      detailTab: 0,
      installmentFilter: "todas",
      installmentsPage: 1,
      installmentsPerPage: 5,
      installmentSortDesc: false,
      agreementsPage: 1,
      agreementsPerPage: 10,
      detailTabs: [
        { key: "dados", label: "Dados" },
        { key: "parcelas", label: "Parcelas" },
        { key: "acordos", label: "Acordos" },
      ],
      installmentFilters: [
        { key: "todas", label: "Todas" },
        { key: "paga", label: "Pagas" },
        { key: "a_vencer", label: "A vencer" },
        { key: "vencida", label: "Vencidas" },
      ],
      installmentStatusMap: {
        paga: { label: "pago", color: "teal" },
        a_vencer: { label: "a vencer", color: "blue" },
        vencida: { label: "vencida", color: "red" },
      },
      columnCardsLimit: {},
      initialCardsPerColumn: 5,
      cardsIncrement: 5,
      hasAppliedRequiredFilters: false,
      filterAlert: "",
      selectedCompany: "",
      selectedStartDate: "",
      selectedEndDate: "",
      selectedStartDateISO: "",
      selectedEndDateISO: "",
      selectMode: "Data da Venda",
      boardViewMode: "kanban",
      mostrarFiltro: true,
      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,
      columns: [],
      tiposEtapaFiltroSelecionados: [],
      tiposEtapaFiltroInicializado: false,
      cards: [],
      companyOptions: [],
      filters: {
        search: "",
        seller: "todos",
        contractType: [],
        lateInstallments: [],
      },
      lateInstallmentOptions: [
        { value: 1, label: "1ª em atraso" },
        { value: 2, label: "2ª em atraso" },
        { value: 3, label: "3ª em atraso" },
      ],
      listHeaders: [
        { text: "Etapa", value: "stageName", width: "150" },
        { text: "Cliente", value: "customerName", width: "220" },
        { text: "Contrato", value: "contractNumber", width: "120" },
        { text: "Tipo", value: "contractType" },
        { text: "Vendedor", value: "sellerName", width: "180" },
        { text: "Venda", value: "saleDate", width: "100" },
        { text: "Mensalidades", value: "totalInstallments", align: "end" },
        { text: "Em atraso", value: "lateInstallments", sortable: false, width: "160" },
        { text: "Vencido", value: "overdueAmount", align: "end" },
      ],
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },
    };
  },
  computed: {
    orderedColumns() {
      return [...this.columns].sort((a, b) => a.order - b.order);
    },
    canViewAllSellers() {
      const roles = this.getUserRoles();
      return (
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_FLUXO_VENDAS_SUPERVISOR")
      );
    },
    filteredCards() {
      const search = (this.filters.search || "").toLowerCase();
      return this.cards.filter((card) => {
        const matchesSearch =
          !search ||
          this.getCardText(card.customerName).includes(search) ||
          this.getCardText(card.code).includes(search);
        const matchesSeller =
          !this.canViewAllSellers ||
          this.filters.seller === "todos" ||
          card.sellerCpf === this.filters.seller;
        const matchesContractType =
          !this.filters.contractType.length ||
          this.filters.contractType.includes(card.contractType);
        const matchesLateInstallments =
          !this.filters.lateInstallments.length ||
          this.filters.lateInstallments.some((numero) =>
            card.lateInstallments.includes(numero),
          );

        return (
          matchesSearch &&
          matchesSeller &&
          matchesContractType &&
          matchesLateInstallments
        );
      });
    },
    boardMetrics() {
      const countBy = (stages) =>
        this.filteredCards.filter((card) => stages.includes(card.stage))
          .length;

      return [
        {
          key: "total",
          label: "Total Contratos",
          value: this.filteredCards.length,
          icon: "mdi-file-document-multiple",
          color: "info",
        },
        {
          key: "adimplentes",
          label: "Total Adimplentes",
          value: countBy([ETAPAS_VENDAS.ADIMPLENTES]),
          icon: "mdi-check-circle",
          color: "success",
        },
        {
          key: "inadimplentes",
          label: "Total Inadimplentes",
          value: countBy(INADIMPLENTES),
          icon: "mdi-alert-circle",
          color: "error",
        },
        {
          key: "cancelados",
          label: "Total Cancelados",
          value: countBy([ETAPAS_VENDAS.CANCELADO]),
          icon: "mdi-cancel",
          color: "warning",
        },
      ];
    },
    tiposEtapaFiltroItems() {
      return this.getTiposEtapaDisponiveis().map((tipo) => ({
        label: tipo,
        color: this.getCorTipoEtapa(tipo),
        count: this.getQuantidadeColunasPorTipo(tipo),
      }));
    },
    visibleColumns() {
      return this.getColunasFiltradas();
    },
    listCards() {
      if (!this.getTiposEtapaFiltroAtivos().length) return this.filteredCards;
      const visibleIds = this.visibleColumns.map((column) => column.id);
      return this.filteredCards.filter((card) => visibleIds.includes(card.stage));
    },
    sellerOptions() {
      const sellers = new Map();
      this.cards.forEach((card) => {
        if (card.sellerCpf && !sellers.has(card.sellerCpf)) {
          sellers.set(card.sellerCpf, card.sellerName || card.sellerCpf);
        }
      });
      return [
        { value: "todos", label: "Todos" },
        ...[...sellers.entries()]
          .map(([value, label]) => ({ value, label }))
          .sort((a, b) => a.label.localeCompare(b.label, "pt-BR")),
      ];
    },
    contractTypeOptions() {
      return [
        ...new Set(this.cards.map((card) => card.contractType).filter(Boolean)),
      ]
        .sort((a, b) => a.localeCompare(b, "pt-BR", { numeric: true }))
        .map((type) => ({ value: type, label: type }));
    },
    customerDataItems() {
      const card = this.selectedCard;
      if (!card) return [];
      const items = [
        {
          key: "phone",
          icon: "mdi-phone-outline",
          value: card.phone || "Telefone não informado",
        },
        {
          key: "email",
          icon: "mdi-email-outline",
          value: card.email || "E-mail não informado",
        },
        {
          key: "sale",
          icon: "mdi-calendar-outline",
          value: `Data Venda: ${this.formatDate(card.saleDate)}`,
        },
        {
          key: "seller",
          icon: "mdi-account-outline",
          value: `Vendedor: ${card.sellerName || "-"}`,
        },
      ];
      if (card.cancellationDate) {
        items.push({
          key: "cancellation",
          icon: "mdi-cancel",
          value: `Cancelamento: ${this.formatDate(card.cancellationDate)}`,
        });
      }
      return items;
    },
    filteredInstallments() {
      if (!this.selectedCard) return [];
      const direction = this.installmentSortDesc ? -1 : 1;
      const dueTime = (installment) => {
        const time = new Date(installment.dueDate).getTime();
        return Number.isNaN(time) ? 0 : time;
      };
      return (this.selectedCard.installments || [])
        .filter(
          (installment) =>
            this.installmentFilter === "todas" ||
            installment.status === this.installmentFilter,
        )
        .sort((a, b) => (dueTime(a) - dueTime(b)) * direction);
    },
    paginatedInstallments() {
      const start = (this.installmentsPage - 1) * this.installmentsPerPage;
      return this.filteredInstallments.slice(
        start,
        start + this.installmentsPerPage,
      );
    },
    totalInstallmentsPages() {
      return Math.ceil(
        this.filteredInstallments.length / this.installmentsPerPage,
      );
    },
    paginatedAgreements() {
      const agreements = (this.selectedCard && this.selectedCard.agreements) || [];
      const start = (this.agreementsPage - 1) * this.agreementsPerPage;
      return agreements.slice(start, start + this.agreementsPerPage);
    },
    totalAgreementsPages() {
      const agreements = (this.selectedCard && this.selectedCard.agreements) || [];
      return Math.ceil(agreements.length / this.agreementsPerPage);
    },
  },
  async mounted() {
    this.setDefaultDateRange();
    this.loadCompanies();
    await this.loadColumns();
    if (this.companyOptions.length === 1) {
      this.applyRequiredFilters();
    } else {
      this.filterAlert =
        "Selecione uma empresa e um período para carregar o fluxo de vendas.";
    }
  },
  methods: {
    async loadColumns() {
      try {
        this.columns = await fluxoVendasService.getColumns();
        this.inicializarFiltroEtapasPadrao();
      } catch (error) {
        console.error("Erro ao carregar etapas do fluxo de vendas:", error);
        this.columns = [];
        this.showSnackbar("Erro ao carregar etapas do fluxo de vendas.", "error");
      }
    },
    inicializarFiltroEtapasPadrao() {
      const tiposValidos = this.getTiposEtapaDisponiveis();

      this.tiposEtapaFiltroSelecionados =
        this.tiposEtapaFiltroSelecionados.filter((tipo) =>
          tiposValidos.includes(tipo),
        );

      if (this.tiposEtapaFiltroInicializado) return;

      this.tiposEtapaFiltroSelecionados = [...tiposValidos];
      this.tiposEtapaFiltroInicializado = true;
    },
    getTiposEtapaDisponiveis() {
      return [
        ...new Set(this.columns.map((coluna) => coluna.tipo).filter(Boolean)),
      ];
    },
    getTiposEtapaFiltroAtivos() {
      return Array.isArray(this.tiposEtapaFiltroSelecionados)
        ? this.tiposEtapaFiltroSelecionados
        : [];
    },
    getQuantidadeColunasPorTipo(tipo) {
      return this.columns.filter((coluna) => coluna.tipo === tipo).length;
    },
    getCorTipoEtapa(tipo) {
      const coluna = this.columns.find((item) => item.tipo === tipo);
      return coluna?.cor || "#607d8b";
    },
    getColunasFiltradas() {
      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (!tiposAtivos.length) return this.orderedColumns;

      return this.orderedColumns.filter((coluna) =>
        tiposAtivos.includes(coluna.tipo),
      );
    },
    async applyRequiredFilters() {
      if (!this.canLoadCards()) return;

      this.isLoading = true;
      try {
        if (!this.columns.length) await this.loadColumns();
        const contratos = await fluxoVendasService.getContratos({
          dataInicio: this.selectedStartDateISO,
          dataFim: this.selectedEndDateISO,
          empresa: this.selectedCompany,
        });
        this.cards = contratos.map((card) => {
          const column = this.columns.find((item) => item.id === card.stage);
          return {
            ...card,
            stageName: column ? column.title : "-",
            stageColor: column ? column.color : "#64748b",
          };
        });
        if (
          this.filters.seller !== "todos" &&
          !this.cards.some((card) => card.sellerCpf === this.filters.seller)
        ) {
          this.filters.seller = "todos";
        }
        this.initializeColumnLimits();
        this.hasAppliedRequiredFilters = true;
        this.filterAlert = "";
      } catch (error) {
        console.error("Erro ao carregar fluxo de vendas:", error);
        this.cards = [];
        this.showSnackbar(
          error.response?.data?.message || "Erro ao carregar fluxo de vendas.",
          "error",
        );
      } finally {
        this.isLoading = false;
      }
    },
    loadCompanies() {
      const empresas = EMPRESAS.filter((empresa) => this.hasPermission(empresa));
      this.companyOptions = empresas.map((empresa) => ({
        text: empresa,
        value: empresa,
      }));
      if (empresas.length === 1) {
        this.selectedCompany = empresas[0];
      } else if (this.selectedCompany && !empresas.includes(this.selectedCompany)) {
        this.selectedCompany = "";
      }
    },
    canLoadCards() {
      if (
        !this.selectedCompany ||
        !this.selectedStartDateISO ||
        !this.selectedEndDateISO
      ) {
        this.hasAppliedRequiredFilters = false;
        this.cards = [];
        this.filterAlert =
          "Informe empresa, data inicial e data final antes de carregar os dados.";
        return false;
      }
      if (new Date(this.selectedStartDateISO) > new Date(this.selectedEndDateISO)) {
        this.hasAppliedRequiredFilters = false;
        this.cards = [];
        this.filterAlert = "A data inicial não pode ser maior que a data final.";
        return false;
      }
      return true;
    },
    getCardsByColumn(columnId) {
      return this.filteredCards.filter((card) => card.stage === columnId);
    },
    getVisibleCardsByColumn(columnId) {
      const limit = this.columnCardsLimit[columnId] || this.initialCardsPerColumn;
      return this.getCardsByColumn(columnId).slice(0, limit);
    },
    hasMoreCards(columnId) {
      const limit = this.columnCardsLimit[columnId] || this.initialCardsPerColumn;
      return this.getCardsByColumn(columnId).length > limit;
    },
    loadMoreCards(columnId) {
      const currentLimit =
        this.columnCardsLimit[columnId] || this.initialCardsPerColumn;
      this.$set(this.columnCardsLimit, columnId, currentLimit + this.cardsIncrement);
    },
    initializeColumnLimits() {
      this.columnCardsLimit = {};
      this.columns.forEach((column) => {
        this.$set(this.columnCardsLimit, column.id, this.initialCardsPerColumn);
      });
    },
    getColumnTotal(columnId) {
      return this.getCardsByColumn(columnId).reduce(
        (total, card) => total + card.overdueAmount,
        0,
      );
    },
    getInstallmentsLabel(card) {
      if (!card.totalInstallments) return "Sem mensalidades lançadas";
      const vencidas = card.overdueInstallments;
      const vencidasLabel = !vencidas
        ? "3 primeiras em dia"
        : vencidas === 1
        ? "1 vencida nas 3 primeiras"
        : `${vencidas} vencidas nas 3 primeiras`;
      return `${card.totalInstallments} lançada(s) • ${vencidasLabel}`;
    },
    getLateInstallmentLabel(numero) {
      return `${numero}ª em atraso`;
    },
    async selectCard(card) {
      this.selectedCard = {
        ...card,
        installments: [],
        agreements: [],
        claims: [],
      };
      this.detailTab = 0;
      this.installmentFilter = "todas";
      this.installmentsPage = 1;
      this.installmentSortDesc = false;
      this.agreementsPage = 1;
      this.detailDialog = true;
      await this.loadCardDetails(card);
    },
    async loadCardDetails(card) {
      if (!card.id_contrato) return;

      this.loadingCardDetails = true;
      try {
        const [installments, agreements, claims] = await Promise.all([
          fluxoVendasService.getInstallments(card.id_contrato),
          fluxoVendasService.getAgreements(card.id_contrato),
          fluxoVendasService.getClaims(card.id_contrato),
        ]);
        if (this.selectedCard && this.selectedCard.id === card.id) {
          this.selectedCard = {
            ...this.selectedCard,
            installments,
            agreements,
            claims,
          };
        }
      } catch (error) {
        console.error("Erro ao carregar detalhes do contrato:", error);
        this.showSnackbar("Erro ao carregar detalhes do contrato.", "error");
      } finally {
        this.loadingCardDetails = false;
      }
    },
    setInstallmentFilter(key) {
      this.installmentFilter = key;
      this.installmentsPage = 1;
    },
    toggleInstallmentSort() {
      this.installmentSortDesc = !this.installmentSortDesc;
      this.installmentsPage = 1;
    },
    getInstallmentStatusConfig(status) {
      return (
        this.installmentStatusMap[status] || {
          label: status || "sem status",
          color: "grey",
        }
      );
    },
    clearFilters() {
      this.filters = {
        search: "",
        seller: "todos",
        contractType: [],
        lateInstallments: [],
      };
    },
    alternarVisibilidade() {
      this.mostrarFiltro = !this.mostrarFiltro;
    },
    limparFiltro() {
      this.selectedCompany = this.companyOptions.length === 1 ? this.selectedCompany : "";
      this.setDefaultDateRange();
      this.hasAppliedRequiredFilters = false;
      this.cards = [];
      this.clearFilters();
    },
    setDefaultDateRange() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth() - 3, 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
      this.selectedStartDateISO = this.formatDateInput(firstDay);
      this.selectedEndDateISO = this.formatDateInput(lastDay);
      this.selectedStartDate = this.convertToBR(this.selectedStartDateISO);
      this.selectedEndDate = this.convertToBR(this.selectedEndDateISO);
    },
    handleStartDateSelection() {
      this.selectedStartDate = this.convertToBR(this.selectedStartDateISO);
      this.isStartDatePickerOpen = false;
    },
    handleEndDateSelection() {
      this.selectedEndDate = this.convertToBR(this.selectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },
    formatDateInput(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    convertToBR(dateString) {
      if (!dateString) return "";
      const [year, month, day] = String(dateString).substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    formatDate(value) {
      if (!value) return "-";
      return this.convertToBR(value);
    },
    formatCurrency(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatCpfMasked(value) {
      if (!value) return "Documento não informado";
      const cpf = String(value).replace(/\D/g, "");
      if (cpf.length !== 11) return value;
      return `${cpf.substring(0, 3)}.***.**${cpf.substring(9, 11)}`;
    },
    getCardText(value) {
      return String(value || "").toLowerCase();
    },
    hasPermission(empresa) {
      const roles = this.getUserRoles();
      if (roles.includes("ROLE_ADMIN")) return true;

      const roleName = empresa.trim().toUpperCase().replace(/\s/g, "_");
      return [`ROLE_${roleName}`, `ROLE_${this.removeAccents(roleName)}`].some(
        (role) => roles.includes(role),
      );
    },
    getUserRoles() {
      const user = JSON.parse(sessionStorage.getItem("user") || "{}");
      return Array.isArray(user.roles) ? user.roles : [];
    },
    removeAccents(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar = { show: true, text, color, timeout };
    },
  },
};
</script>

<style scoped>
.fluxo-vendas-page {
  background-color: #f8f9fb;
}

.fluxo-vendas-page >>> .v-application--wrap {
  background-color: #f8f9fb;
}

.indicadores-container {
  background-color: #eee;
  padding-bottom: 0;
}

.board-filter-input >>> .v-input__slot {
  min-height: 40px !important;
}

.board-filter-input >>> .v-label {
  font-size: 0.84rem;
}

.filter-row {
  align-items: flex-end;
  gap: 0;
}

.filter-row .col,
.filter-row [class*="col-"],
.board-filters-row .col,
.board-filters-row [class*="col-"] {
  padding-top: 4px;
  padding-bottom: 4px;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  padding-top: 8px;
}

.filter-actions .v-btn {
  margin-right: 0 !important;
  white-space: nowrap;
}

.board-filter-input {
  background: transparent;
  border-radius: 4px;
}

.board-filters-row {
  align-items: center;
}

.board-filter-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 auto;
  max-width: 72px;
  padding-left: 4px;
}

.subtle-action-btn {
  min-height: 32px !important;
  border-radius: 4px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

.subtle-action-btn:hover {
  background: #f8fafc;
}

.fluxo-view-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.fluxo-view-toggle {
  display: inline-flex;
  padding: 0;
  background: #f8fafc;
  overflow: hidden;
}

.fluxo-view-toggle .v-btn {
  box-shadow: none !important;
  border-radius: 0 !important;
  min-width: 86px !important;
  height: 34px !important;
  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
  font-weight: 600;
  color: #475569 !important;
  background: transparent !important;
  transition: 0.18s;
}

.fluxo-view-toggle .v-btn:first-child {
  border-radius: 5px 0 0 5px !important;
}

.fluxo-view-toggle .v-btn:last-child {
  border-radius: 0 5px 5px 0 !important;
}

.fluxo-view-toggle .v-btn--active {
  background: #111827 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18) !important;
}

.fluxo-view-toggle .v-btn--active .v-icon {
  color: white !important;
}

.fluxo-view-toggle .v-btn .v-icon {
  margin-right: 6px;
}

.ticket-list-view {
  overflow: visible;
  padding-bottom: 2rem;
}

.ticket-list-table {
  background: #fff;
}

.ticket-list-table >>> th {
  font-size: 11px !important;
  font-weight: bold !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.pointer {
  cursor: pointer;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.lista-subtexto {
  color: #64748b;
  font-size: 10px;
  font-weight: 400;
  margin-top: 2px;
}

.etapa-lista-cell {
  width: 150px;
}

.cliente-lista-cell {
  width: 220px;
}

.kanban-board {
  padding: 16px;
  overflow-x: auto;
  padding-top: 0;
  padding-bottom: 12px;
}

.kanban-columns {
  display: flex;
  gap: 16px;
  min-height: calc(100vh - 30vh);
}

.kanban-column {
  min-width: 280px;
  max-width: 320px;
  flex: 0 0 300px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.column-header {
  min-height: 90px;
  padding: 14px;
  border-top: 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px 4px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.column-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex: 0 0 auto;
}

.column-title {
  margin: 0;
  color: #ffffff;
  font-size: 0.98rem;
  font-weight: 700;
}

.column-description {
  margin: 1px 0 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.76rem;
  line-height: 1.25;
}

.column-stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  font-size: 0.86rem;
}

.card-list {
  min-height: 180px;
  padding: 0 12px 12px;
  flex: 1;
  overflow-y: auto;
  background: #fafafa;
}

.finance-card {
  margin-bottom: 12px;
  margin-top: 8px;
  border: 1px solid #e0e0e0;
  border-left: 6px solid;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: 0.2s ease;
}

.finance-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.card-code {
  color: #616161;
  font-size: 0.72rem;
  font-weight: 700;
}

.card-customer {
  margin: 2px 0 0;
  color: #424242;
  font-size: 0.94rem;
  line-height: 1.25;
}

.card-customer-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex-wrap: wrap;
}

.card-description {
  margin: 10px 0;
  color: #616161;
  font-size: 0.82rem;
  line-height: 1.35;
}

.card-amount-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  color: #616161;
  font-size: 0.8rem;
}

.card-amount-row > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.card-amount-row small {
  margin-top: 2px;
  color: #78909c;
  font-size: 0.72rem;
  line-height: 1.15;
}

.card-amount-row strong {
  color: #424242;
  font-size: 1rem;
  white-space: nowrap;
}

.card-dates {
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
  margin-top: 9px;
  padding: 7px 0;
  border-bottom: 1px solid #eeeeee;
  color: #607d8b;
  font-size: 0.76rem;
}

.card-dates span {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.card-dates strong {
  color: #455a64;
  font-weight: 700;
}

.card-meta {
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
  margin-top: 7px;
  color: #757575;
  font-size: 0.78rem;
}

.card-meta span {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.empty-column {
  min-height: 120px;
  border: 1px dashed #d0d0d0;
  border-radius: 8px;
  color: #9e9e9e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.82rem;
  margin-top: 1rem;
}

.load-more-btn {
  background-color: #f5f5f5 !important;
  border: 1px dashed #bdbdbd;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}

.load-more-btn:hover {
  background-color: #eeeeee !important;
  border-color: #9e9e9e;
}

.customer-dialog {
  border-radius: 8px;
  position: relative;
}

.dialog-close-btn {
  position: absolute;
  top: 16px;
  right: 5px;
  z-index: 10;
  background-color: white;
}

.dialog-title {
  align-items: flex-start;
  padding-right: 56px !important;
}

.dialog-body {
  padding: 0 24px 18px !important;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
}

.dialog-customer {
  margin: 0;
  color: #424242;
  font-size: 1.2rem;
  font-weight: 800;
  line-height: 1.25;
  text-align: start;
}

.dialog-contract {
  margin-top: 4px;
  color: #757575;
  font-size: 0.86rem;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dialog-amount {
  min-width: 148px;
  text-align: right;
}

.dialog-amount span {
  display: block;
  color: #757575;
  font-size: 0.76rem;
}

.dialog-amount strong {
  display: block;
  color: #424242;
  font-size: 1.35rem;
  line-height: 1.2;
}

.dialog-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 16px;
}

.detail-section {
  padding-top: 16px;
}

.section-kicker {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #616161;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 26px;
}

.data-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #424242;
  font-size: 0.86rem;
}

.data-item span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.min-width-0 {
  min-width: 0;
}

.custom-tabs {
  background-color: #fafafa;
  margin-top: 0px;
}

.custom-tabs .v-tab {
  color: #616161;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.custom-tabs .v-tab--active {
  color: #3055a4;
}

.detail-tabs-content {
  background: transparent;
}

.section-title {
  margin: 8px 0 4px;
  color: #424242;
  font-size: 0.98rem;
  font-weight: 800;
}

.section-subtitle {
  margin: 2px 0 14px;
  color: #888;
  font-size: 14px;
  font-weight: 300;
}

.record-row,
.installment-row {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
}

.record-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  margin-top: 8px;
}

.record-row strong,
.record-row span {
  display: block;
}

.record-row strong {
  color: #424242;
  font-size: 0.86rem;
}

.record-row span {
  color: #757575;
  font-size: 0.78rem;
}

.installment-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  color: #757575;
  font-size: 0.8rem;
}

.installment-row {
  display: grid;
  grid-template-columns: auto minmax(130px, 0.8fr) minmax(150px, 1fr) minmax(
      210px,
      1.3fr
    );
  align-items: center;
  gap: 16px;
  padding: 8px 14px;
  margin-bottom: 8px;
}

.installment-status {
  min-width: 72px;
  justify-content: center;
  font-weight: 600;
  text-transform: uppercase;
}

.installment-main,
.installment-values,
.installment-dates {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.installment-main strong,
.installment-values strong {
  color: #424242;
  font-size: 0.88rem;
}

.installment-main span,
.installment-values span,
.installment-dates {
  color: #757575;
  font-size: 0.76rem;
}

.installment-values {
  grid-template-columns: auto auto;
  column-gap: 10px;
}

.installment-values strong {
  text-align: right;
}

.installment-values .received-value {
  color: #00897b;
}

.installment-dates span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.late-chip {
  background-color: #fdecea !important;
  color: #c62828 !important;
  font-weight: 700;
}

.late-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.empty-detail {
  min-height: 80px;
  border: 1px dashed #d0d0d0;
  border-radius: 8px;
  color: #9e9e9e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.86rem;
}
</style>
